// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrumbs[data-v-6b8a5c0a]{width:100%;box-sizing:border-box;display:flex;flex-wrap:wrap;justify-content:flex-start;align-items:center;padding:16px 16px 16px clamp(1rem,-1.393rem + 11.964vw,9.375rem)}.breadcrumbs__lien[data-v-6b8a5c0a]{text-decoration:none}.breadcrumbs__texte[data-v-6b8a5c0a]{padding:4px;font-weight:400}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
